// Module
var code = "<div class=\"c-datatable-drillableCell u-sizeFullWidth ui-grid-cell-contents\">\n    <div class=\"u-flex u-flexMiddle\">\n        <div class=\"c-link\" smart-truncate ng-click=\"grid.appScope.openProductDetailsPage(row.entity.Id)\" ng-bind=\"row.entity.ProductName\"></div>\n    </div>\n</div>\n";
// Exports
module.exports = code;